// Pragmatic RFC 5322 — matches valid practical addresses, avoids over-strict edge cases.
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const isValidEmail = (v: string): boolean => EMAIL_RX.test(v.trim());

// Accepts a comma/semicolon-separated list; empty input is NOT valid (use isValidEmail on optional fields).
export const isValidEmailList = (v: string): boolean => {
  const parts = v.split(/[,;]/).map((s) => s.trim()).filter(Boolean);
  return parts.length > 0 && parts.every(isValidEmail);
};
